// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2cRtt","subheader":"ReorderModal_subheader__1bcg1","listWrap":"ReorderModal_listWrap__2yfbe"};